<form odxForm [formGroup]="showGroupVisibilityForm">
  <odx-switch i18n="@@button.toggleGroupVisibility" [(checked)]="isSelected" formControlName="showGroupVisibility"
    >Gruppe anzeigen</odx-switch
  >
</form>
